import React from "react";
import { ReactComponent as CompanySvgIcon } from "../images/ins2-icon-companies.svg";
import { ReactComponent as DocumentTypeIcon } from "../images/ins2-icon-documents.svg";
import { ReactComponent as DocumentIcon } from "../images/irm-icon-documents.svg";
import { ReactComponent as EventIcon } from "../images/irm-icon-events.svg";
import { ReactComponent as ConnectorsIcon } from "../images/ins2-icon-connectors.svg";
import { ReactComponent as UserIcon } from "../images/irm-icon-users.svg";
import { ReactComponent as SystemSvgIcon } from "../images/irm-icon-system.svg";
import {
    companyPermissionOptions,
    usersPermissionOptions,
    platformPermissionOptions,
    assetsPermissionOptions
} from '../Utils/Common';
import { DocumentTypes, Documents, Events, Users, Connectors, System } from "../pages";
import Companies from "../pages/Companies/Companies";

// hack: wrapper around svg react component to deal with spacing issue
const CompanyIcon = () => {
    return (
        <CompanySvgIcon style={{ "marginLeft": 5 }} />
    );
};

const SystemIcon = () => {
    return (
        <SystemSvgIcon style={{ "marginLeft": 5 }} />
    );
};

export const DRAWER_LIST = [
    {
        component: <Companies/>,
        text: 'Companies',
        icon: CompanyIcon,
        permission: companyPermissionOptions
    },
    {
        component: <Documents />,
        text: 'Documents',
        icon: DocumentIcon,
        permission: assetsPermissionOptions
    },
    {
        component: <DocumentTypes />,
        text: 'Document Types',
        icon: DocumentTypeIcon,
        permission: assetsPermissionOptions
    },
    {
        component: <Events />,
        text: 'Events',
        icon: EventIcon,
        permission: platformPermissionOptions
    },
    {
        component: <Connectors />,
        text: 'Connectors',
        icon: ConnectorsIcon,
        permission: platformPermissionOptions
    },
    {
        component: <Users />,
        text: 'Users',
        icon: UserIcon,
        permission: usersPermissionOptions
    },
    {
        component: <System />,
        text: 'System',
        icon: SystemIcon,
        permission: platformPermissionOptions
    },

];